//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

let hh = $('#site_header').outerHeight();
document.documentElement.style.setProperty('--hh', `${hh}px`);

let fh = $('#site_footer').outerHeight();
document.documentElement.style.setProperty('--fh', `${fh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  let hh = $('#site_header').outerHeight();
  document.documentElement.style.setProperty('--hh', `${hh}px`);

  let fh = $('#site_footer').outerHeight();
  document.documentElement.style.setProperty('--fh', `${fh}px`);
});

//Shopify format money function
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function(){

  Marquee3k.init();

  //Product Thumb Update Price
  $('.thumb_variant_selector').change(function(){
    var $this = $(this);
    var $index = $this.prop('selectedIndex');
    var $price = $this.parent().find('.variant_prices .price').eq($index).text();
    $this.parents('.product_thumb').find('.current_price').text($price);
  });

  // Animate In Sections
  $('.animate-in:in-viewport').addClass('in-viewport');

  //Cart Drawer
  $('body').on('click','.toggle_cart',function(e){
    e.preventDefault();
    $('#side_cart, #cart_mask').toggleClass('open');
  });

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Ajax Change Quantity in Cart
  $('body').on('click','.side_cart_quantity',function(event){
    event.preventDefault();
    var $quantity = $(this).attr('data-qty');
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']='+$quantity+'',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Age Overlay
  if ( Cookies.get('age-accepted') ) {
  } else {
    $('#age_overlay').addClass('open');
  }
  $('#age_overlay .age_yes').click(function(){
    $('#age_overlay').remove();
    Cookies.set('age-accepted', true, { expires: 1 });
  });
  $('#age_overlay .age_no').click(function(){
    history.back();
  });

  //Toggle Menu
  $('.toggle_menu').click(function(){
    $('.toggle_menu').toggle();
    $('#main_menu').toggleClass('open');
    $('#site_header').toggleClass('menu-open');
  });

  //Toggle Search
  $('.toggle_search').click(function(){
    $('.toggle_search').toggle();
    $('#search_overlay').toggleClass('open');
    $('#site_header').toggleClass('search-open');
  });

  //Homepage Slideshow
  var homeSwiper = new Swiper('.home_slideshow.swiper-container', {
    effect: 'fade',
    speed: 1400,
    allowTouchMove: false,
    simulateTouch: false,
    loop: true,
    autoplay: {
      delay: 3500,
    },
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    },
    on: {
      init: function(){
        if ( $('.swiper-slide-active').hasClass('white') ) {
          $('#site_header, .next, .prev').addClass('white');
        } else {
          $('#site_header, .next, .prev').removeClass('white');
        }
      },
      slideChangeTransitionStart: function(){
        if ( $('.swiper-slide-active').hasClass('white') ) {
          $('#site_header, .next, .prev').addClass('white');
        } else {
          $('#site_header, .next, .prev').removeClass('white');
        }
      }
    }
  });

  //Product Slideshow
  var productSwiper = new Swiper('.product_slideshow.swiper-container', {
    
  });
  //Product Thumb Images
  $('.product_thumbs img').click(function(){
    var $target = $(this).attr('data-index') - 1;
    productSwiper.slideTo($target,0);
  })

  //Add Class to Home Image if there's an announcement bar
  if ( $('#announcement_bar').length ) {
    $('.home_image, .home_intro, #MainContent').addClass('has-top-bar');
  }

  //Password Protected Articles
  $('#password_protected').submit(function(e){
    e.preventDefault();
    var $pw = $('#password').val();
    if ( $pw == $('#password_protected').attr('data-pw') ) { 
      $('.protected_article').show();
      $('section.password').hide();
      $('.animate-in:in-viewport').addClass('in-viewport');
    } else {
      alert('Sorry, incorrect password! Please try again');
    }
  });

  //Fix Top Margin with announcement bar
  /*if ( $('#site_header').hasClass('home')) {
    $headerHeight = $('#site_header').outerHeight();
    $('.home_image:first-child, .home_intro:first-child').css('margin-top',$headerHeight);
  }*/

  //Free Shipping Popup
  if ( $('#free_shipping_popup').length ) {
    if ( !$('#free_shipping_popup').hasClass('dont-show') ) {
      setTimeout(function(){
        $('#free_shipping_popup').addClass('show');
        setTimeout(function(){
          $('#free_shipping_popup').removeClass('show');
        },5000);
      },1000);
    }
  }

  //Submenus for Touch
  if ( Modernizr.touchevents) {
    $('a.submenu_parent').click(function(e){
      e.preventDefault();
      var $this = $(this);
      var $href = $(this).attr('href');
      if ( $this.parent().find('.submenu').hasClass('open') ) {
        window.location = $href;
      } else {
        $this.parent().find('.submenu').addClass('open');
      }
    })
  }

  //Build a Box
  if ( $('#build_a_box').length ) {
    var boxNumber = 0;
    var items = [];
    var cost = 0;
    //console.log(boxNumber);
    $('.plus').click(function(){
      var $maxCans = 999;
      if ( boxNumber < $maxCans ) {
        if ( $(this).parents('.bab_product').attr('data-qty') == $(this).parents('.bab_product').attr('data-inventory')  ) {
          alert('Sorry, you already have all the remaining stock of this product in your box!');
        } else {
          boxNumber++;
          //console.log('Cans in Box: ' + boxNumber);
          $('#box li').each(function(index){
            var $this = $(this);
            if(index < boxNumber){
              $this.addClass('active');
            } else {
              $this.removeClass('active');
            }
          });

          var $lineAmount = parseInt($(this).parents('.qty_controls').find('.current').html());
          $lineAmount++;
          //console.log('Amount of this product: ' + $lineAmount);
          $(this).parents('.qty_controls').find('.current').html($lineAmount);
          $(this).parents('.bab_product').attr('data-qty',$lineAmount);

          if (boxNumber > 0) {
            $('#bab_cta').removeClass('disabled').html('Checkout');
          } else {
            $('#bab_cta').addClass('disabled').html('Add more Cans!');
          }

          recalculateBox();
        }

      } else {
        alert('Your box is already full!');
      }
    });
    $('.minus').click(function(){
      if ( $(this).parents('.bab_product').attr('data-qty') == 0  ) {

      } else {
        if ( boxNumber > 0 ) {
          boxNumber--;
          if ( boxNumber < 6 ) {
            $('#bab_cta').addClass('disabled').html('Add more Cans!');
          }
          
          //console.log('Cans in Box: ' + boxNumber);
          $('#box li').each(function(index){
            var $this = $(this);
            if(index < boxNumber){
              $this.addClass('active');
            } else {
              $this.removeClass('active');
            }
          });

          var $lineAmount = parseInt($(this).parents('.qty_controls').find('.current').html());
          $lineAmount--;
          //console.log('Amount of this product: ' + $lineAmount);
          $(this).parents('.qty_controls').find('.current').html($lineAmount);
          $(this).parents('.bab_product').attr('data-qty',$lineAmount);

          recalculateBox();

        } else {
          alert('Your box is empty!');
        }
      }
    });

    $('body').on('click','#bab_cta',function(e){
      console.log('clicked add to cart');
      $('#bab_cta').html('Adding...');
      $.post('/cart/add.json', {
        items: jsonObj
      })
      .done(function() {
        console.log( "success" );
        window.location.href = "/cart";
      })
      .fail(function() {
        console.log( "error" );
      });
    });

  }

});

jsonObj = [];

function recalculateBox(){
  items = [];
  jsonObj = [];
  cost = 0;
  $('.bab_product').each(function(){
    var $variant = $(this).attr('data-variant');
    var $qty = $(this).attr('data-qty');
    var $cost = $(this).attr('data-cost');
    var $totalLineCost = $cost * $qty;
    cost = cost + $totalLineCost;
    var $string = $variant + ':' + $qty;
    if ( $qty > 0 ) {
      items.push($string);
    }

    item = {}
    item["quantity"] = $qty;
    item["id"] = $variant;
    jsonObj.push(item);
  });

  console.log(jsonObj);

  var $totalBoxCost = Shopify.formatMoney(cost, "£{{amount}}");
  console.log($totalBoxCost);
  $('#bab_cost').html($totalBoxCost);
}



$(window).scroll(function(){
  // Animate In Sections
  $('.animate-in:in-viewport').addClass('in-viewport');

  if ( $(document).scrollTop() > 100 ) {
    $('#cart_button_scroll').addClass('visible');
  } else {
    $('#cart_button_scroll').removeClass('visible');
  }
});